import { useState } from 'react'
import { ImageProps } from 'rebass'

import { ReactComponent as CircleDashed } from '../../assets/svg/circle_dashed.svg'
import useTheme from '../../hooks/useTheme'

const BAD_SRCS: { [tokenAddress: string]: true } = {}

interface LogoProps extends Pick<ImageProps, 'style' | 'alt' | 'className' | 'title'> {
  srcs: string[]
}

/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */
export default function Logo({ srcs, alt, title, style, ...rest }: LogoProps) {
  const [, refresh] = useState<number>(0)

  const theme = useTheme()

  const src: string | undefined = srcs.find((src) => !BAD_SRCS[src])

  if (src) {
    return (
      <img
        {...rest}
        alt={alt}
        title={title}
        src={src}
        style={style}
        onError={() => {
          if (src) BAD_SRCS[src] = true
          refresh((i) => i + 1)
        }}
      />
    )
  }

  return (
    <CircleDashed
      {...rest}
      style={{
        ...style,
        background: 'transparent',
        color: style?.color ? style?.color : theme.bg4,
        fill: style?.color ? style?.color : theme.bg4,
      }}
    />
  )
}
